import type { InputHTMLAttributes } from 'react';
import FieldFrame, { controlBase, describedBy } from './FieldFrame';
import { cx } from '../lib/cx';

interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  id: string;
  label: string;
  hint?: string;
  error?: string;
}

export default function Field({ id, label, hint, error, className, ...rest }: FieldProps) {
  return (
    <FieldFrame id={id} label={label} hint={hint} error={error}>
      <input
        id={id}
        aria-describedby={describedBy(id, hint, error)}
        aria-invalid={error ? true : undefined}
        className={cx(controlBase, error ? 'border-alert' : 'border-grey-300', className)}
        {...rest}
      />
    </FieldFrame>
  );
}
